export default __webpack_public_path__ + "static/media/404.8516f945.png";